import React from "react";
import { formatEditionBreadcrumbLabel } from "../../lib/contentDate";

const EditionDateBreadcrumb = ({
  dateKeys,
  selectedDateKey,
  londonToday,
  onSelectDateKey,
  disabled,
}) => {
  if (!dateKeys?.length || !londonToday) return null;

  return (
    <nav aria-label="Edition dates" className="edition-date-breadcrumb-wrap">
      <ol className="edition-date-breadcrumb list-unstyled d-flex flex-wrap mb-0">
        {dateKeys.map((dateKey, index) => {
          const isActive = dateKey === selectedDateKey;
          const label = formatEditionBreadcrumbLabel(dateKey, londonToday);
          return (
            <li
              key={dateKey}
              className={`edition-date-breadcrumb-item${isActive ? " is-active" : ""}`}
            >
              {index > 0 ? (
                <span className="edition-date-breadcrumb-sep" aria-hidden="true">
                  &gt;
                </span>
              ) : null}
              {isActive ? (
                <span className="edition-date-breadcrumb-current" aria-current="date">
                  {label}
                </span>
              ) : (
                <button
                  type="button"
                  className="edition-date-breadcrumb-btn"
                  disabled={disabled}
                  onClick={() => onSelectDateKey(dateKey)}
                >
                  {label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default EditionDateBreadcrumb;
